<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title">نمایش پیامک ها</h6>
            <router-link type="button" class="btn btn-outline-success" v-if="can('sms.send')" :to="{name: 'sms.create'}">ارسال پیامک</router-link>
          </div>
          <div v-if="data!=null" class="row py-4">
            <div class="col-6">
              <button :class="[ butt=='send' ? 'btn btn-outline-primary btn-block active' : 'btn btn-outline-info btn-block']" @click="changeAction('send')">ارسالی</button>
            </div>
            <div class="col-6">
              <button :class="[ butt=='receive' ? 'btn btn-outline-danger btn-block active' : 'btn btn-outline-success btn-block']" @click="changeAction('receive')">دریافتی</button>
            </div>
          </div>
          <div class="d-flex justify-content-center height" v-if="data==null" >
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">در حال بارگذاری ...</span>
            </div>
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>متن پیام</th>
                  <th>موبایل</th>
                  <th>فعالیت</th>
                  <th>تاریخ</th>
                  <th>گیرنده</th>
                  <th>ارسال کننده</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(message , index) in data" :key="index">
                  <td>{{index+1}}</td>
                  <td v-text="message.message"></td>
                  <td v-text="message.phone"></td>
                  <td v-text="message.faAction"></td>
                  <td v-text="message.faDate"></td>
                  <td>
                    <div v-if="message.action=='send'">
                      {{message.receiver.name}}
                    </div>
                    <div v-else>
                      اتوماسیون
                    </div>
                  </td>
                  <td>
                    <div v-if="message.action=='receive'">
                      {{message.receiver.name}}
                    </div>
                    <div v-else>
                      {{message.sender.name}}
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>ردیف</th>
                  <th>متن پیام</th>
                  <th>موبایل</th>
                  <th>فعالیت</th>
                  <th>تاریخ</th>
                  <th>گیرنده</th>
                  <th>ارسال کننده</th>
                </tr>
              </tfoot>
            </table>
            <paginations :count="pagination.count" :current="pagination.currentPage" v-on:pages="page"></paginations>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination.js'
import paginations from '@/components/partials/paginations.vue'
export default {
  name: 'SmsIndex',
  mixins: [pagination],
  components: {
    paginations
  },
  data () {
    return {
      data: null,
      type: 'get',
      url: '/api/sms',
      butt: null
    }
  },
  beforeCreate () {
    this.$send.submit('get', 'api/getReciveSms')
  },
  methods: {
    changeAction (action) {
      this.url = '/api/sms/' + action
      this.start()
      this.butt = action
    }
  }
}

</script>
